<template>
    
  <div class="page-home-m" @click.stop="closeShade" >
    <Header-m></Header-m>
    <div class="home-adCarousel">
      <swiper ref="mySwiper" :options="swiperOptions" >
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-4"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-1" @click="jump('/try_m','3')"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-2" @click="jump('/productCenter_m','3')"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="adCarousel-item adCarousel-item-3" @click="jump('/productDetails_m','3')"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="home-company"></div>
    <div class="home-propaganda ui-flex ui-flex-justify-center ui-flex-align-center" >
         <video
          class="shade-propaganda"
          poster="./propaganda.png"
          controls="controls"
          controlsList="nodownload"
          src="http://easygas-other.oss-cn-beijing.aliyuncs.com/propaganda.mp4"
          width="300"
        ></video>
    </div>
    <div class="home-about">
      <div class="about-title-wrap ui-flex ui-flex-justify-center">
        <div class="about-title ui-flex ui-flex-justify-center ui-flex-align-center" @click="jump('/about_m')">
          关于我们
          <i class="title-icon"></i>
        </div>
      </div>
      <div class="about-content ui-flex ui-flex-justify-space-between"></div>
      <div class="about-more-wrap ui-flex ui-flex-justify-center">
        <div class="about-more ui-flex ui-flex-justify-center ui-flex-align-center" @click="jump('/productCenter_m')">
            更多产品
            <i class="more-icon"></i>
        </div>
      </div>
      
    </div>

    <div class="home-cooperation ">
      <div class="cooperation-title">合作单位</div>
        <div class="cooperation-part2">
          
          <swiper ref="mySwiper" :options="swiperOptions2">
            <swiper-slide>
              <ul class="part2-list ui-flex ">
                <li class="part2-list-li part2-list-li-1"></li>
                <li class="part2-list-li part2-list-li-2"></li>
                <li class="part2-list-li part2-list-li-3"></li>
              </ul>
            </swiper-slide>
            <swiper-slide>
              <ul class="part2-list ui-flex ">
                <li class="part2-list-li part2-list-li-4"></li>
                <li class="part2-list-li part2-list-li-5"></li>
                <li class="part2-list-li part2-list-li-6"></li>
              </ul>
            </swiper-slide>
            <swiper-slide>
              <ul class="part2-list ui-flex ">
                <li class="part2-list-li part2-list-li-7"></li>
                <li class="part2-list-li part2-list-li-8"></li>
                <li class="part2-list-li part2-list-li-9"></li>
              </ul>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
    </div>
    <Menu path="/index_m" ref="closeShade"></Menu>
  </div>

</template>

<script>
  import HeaderM from '@/components/wap/HeaderM/index.vue'
  import Menu from '@/components/wap/Menu/index.vue'
  import router from '@/router'
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    components: {
      Swiper,
      SwiperSlide,
      HeaderM,
      Menu,
    },
    directives: {
      swiper: directive
    },
    data() {
      return {
        //banner轮播图
        swiperOptions: {
          speed:1000,
          autoplay:true,
          autoplay: {
                disableOnInteraction: false,
              },
          autoplayStopOnLast:false,
          pagination: {
            el: '.swiper-pagination'
          },
        
        },
        //合作伙伴轮播图
        swiperOptions2: {
          autoplay:true,
          autoplay: {
                disableOnInteraction: false,
              },
          autoplayStopOnLast:false,
        
          pagination: {
            el: '.swiper-pagination'
          },
        }
      }
    },
    beforeCreate(){
      require('../../../static/js/adaptation.js')
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    mounted() {
    },
    methods: {
       /**
       * 点击跳转
      */
      jump (value,type) {

        router.push({
          path: value,
          query:{type},
        }).catch(err => {
          console.log(err)
        })
        

      },
      closeShade(){
        this.$refs.closeShade.closeShade();
      },
    },
    
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>